export enum DirectionEnum {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}
